// @flow
import * as React from 'react';
import { Box, Stack, Flex, Text } from '@locus-taxy/neo-ui';
import { getGroupedSlots, getSortedSlots } from './helper';

type Props = {
    slots: Array<{ startTime: string, endTime: string }>
};

const VisualSlotsList = ({ slots }: Props): React.Node => {
    const orderedSlots = getSortedSlots(slots);
    const groupedSlots = getGroupedSlots(orderedSlots);

    return (
        <Box>
            <Stack space="small">
                {groupedSlots.map(({ groupLabel, slots }) => {
                    return (
                        <Stack space="xxSmall" key={groupLabel}>
                            <Flex justifyContent="center">
                                <Text
                                    fontSize={1}
                                    fontWeight="600"
                                    color="grey.400"
                                >
                                    {groupLabel}
                                </Text>
                            </Flex>
                            {slots.map(({ label }) => (
                                <Flex
                                    width="100%"
                                    key={label}
                                    borderRadius={2}
                                    backgroundColor="grey.200"
                                    alignItems="center"
                                    height="20px"
                                    px={1}
                                    py={2}
                                >
                                    <Text color="grey.800" fontSize={1}>
                                        {label}
                                    </Text>
                                </Flex>
                            ))}
                        </Stack>
                    );
                })}
            </Stack>
        </Box>
    );
};

export default VisualSlotsList;
